import React from 'react';

import LocalizedStrings from 'react-localization';

class Localization extends React.Component {
  static strings = new LocalizedStrings({
    en:{
      ACCEPT: "Accept",
      ACCOUNT_SETTINGS: "Account Settings",
      ADD: "Add",
      ADD_CONTENT: "Add Content",
      ADD_MIND_MAP_FILL_IN_BOX: "ADD_MIND_MAP_FILL_IN_BOX",
      ADD_MIND_MAP_LABLE_BOX: "ADD_MIND_MAP_LABLE_BOX",
      ADMIN_TASK: "Admin Task",
      ALL_SCHOOLS: "All Schools",
      ALL_USERS: "All Users",
      ALWAYS: "Always",
      ANSWER_SIZE: "Answer Size",
      ATTACHMENT:"Attachment",
      AUTHOR: "Author",
      BACK: "Back",
      CANCEL: "Cancel",
      CATEGORY: "Category",
      CATEGORY_CREATION: "CATEGORY_CREATION",
      CATEGORY_EXPERIENCE: "CATEGORY_EXPERIENCE",
      CATEGORY_EXPERIMENT: "CATEGORY_EXPERIMENT",
      CATEGORY_EXPLORATION: "CATEGORY_EXPLORATION",
      CATEGORY_NONE: "CATEGORY_NONE",
      CATEGORY_KNOWLEDGE: "CATEGORY_KNOWLEDGE",
      CHANGE: "Change",
      CHANGE_PASSWORD: "Change Password",
      CHOICE: "CHOICE",
      CLEAR: "Clear",
      CLEAN_UP_ALL_VITALS: "Clean up all VITALS",
      CLEAN_UP_HIDDEN_VITALS: "Clean up hidden VITALS",
      CLEAN_UP_UNUSED_FILES: "Clean up unused files",
      CLOSE: "Close",
      COLOR: "Color",
      COLUMN: "Column",
      COMPARE_ANSWERS: "Compare Answers",
      CONTENT: "Content",
      CONTENT_NAME: "Content Name",
      CONTENT_PHOTO_FILE_INSTRUCTION: "CONTENT_PHOTO_FILE_INSTRUCTION",
      CONTENT_TYPE: "Content Type",
      CONTINUE_EDITING: "Continue Editing",
      CORRECT: "Correct",
      CORRECT_ANSWER: "Correct Answer",
      COVER_IMAGE: "Cover Image",
      CREATE: "Create",
      CREATE_FAILED: "Create Failed",
      CREATE_SCHOOL: "Create School",
      CREATE_USER: "Create User",
      CREATED: "Created",
      DARK_MODE: "Dark Mode",
      DATE_INVALID_REMINDER: "Date is invalid",
      DECLINE: "Decline",
      DEFAULT: "Default",
      DELETE: "Delete",
      DELETE_CONTENT: "Delete Content",
      DELETE_FAILED: "Delete Failed",
      DELETE_FILE: "Delete File",
      DELETE_HOTSPOT: "Delete Hotspot",
      DELETE_LOCALE: "Delete Locale",
      DELETE_MIND_MAP_BOX: "DELETE_MIND_MAP_BOX",
      DELETE_MIND_MAP_LINK: "DELETE_MIND_MAP_LINK",
      DELETE_REMINDER: "Are you sure to delete it? This action is irreversible.",
      DELETE_STAGE: "Delete Stage",
      DELETE_VITALS: "Delete VITALS",
      DELETED: "Deleted",
      DEPLOYMENT: "Deployment",
      DESCRIPTION: "Description",
      DESCRIPTION_AUDIO: "DESCRIPTION_AUDIO",
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER: "DESCRIPTION_FILL_IN_THE_BLANK_AFTER",
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: "DESCRIPTION_FILL_IN_THE_BLANK_BEFORE",
      DESCRIPTION_IMAGE: "DESCRIPTION_IMAGE",
      DESCRIPTION_QUESTION: "DESCRIPTION_QUESTION",
      DESCRIPTION_TAKE_PHOTO: "DESCRIPTION_TAKE_PHOTO",
      DESCRIPTION_TAKE_RECORD: "DESCRIPTION_TAKE_RECORD",
      DESCRIPTION_TEXT: "DESCRIPTION_TEXT",
      DESCRIPTION_VIDEO: "DESCRIPTION_VIDEO",
      DESTINATION: "Destination",
      DETAILS: "Details",
      DIFFICULTY: "Difficulty",
      DISCARD: "Discard",
      DISCARD_CHANGES: "Discard Changes",
      DISPLAY_NAME: "Display Name",
      DISPLAY_NAME_BLANK_REMINDER: "Display name cannot be blank",
      DONE: "Done",
      DONE_EDITING: "Done Editing",
      DURATION: "Duration",
      EDIT: "Edit",
      EDIT_CONTENT: "Edit Content",
      EDIT_ELEMENT: "Edit Element",
      EDIT_STAGE: "Edit Stage",
      EDIT_STAGES: "Edit Stages",
      EDIT_USER: "Edit User",
      ELEMENT_DESCRIPTION_MC: "Multiple-choice question (4 choices with at least 1 correct answer)",
      ELEMENT_DESCRIPTION_PORTAL: "Transfer to other stages (4 stages max)",
      ELEMENT_DESCRIPTION_TAG: "Display information (text, voice or image)",
      ELEMENT_DESCRIPTION_TELEPORT: "Navigate from one stage to another",
      ELEMENT_DESCRIPTION_TREASURE: "Hidden text to be sought by students",
      ELEMENT_DESCRIPTION_VOICE_ANSWER: "Record audio to answer questions",
      ELEMENT_POSITION: "Element Position",
      ELEMENT_TYPE: "Element Type",
      ELEMENT_TYPE_MC: "MC",
      ELEMENT_TYPE_PORTAL: "Portal",
      ELEMENT_TYPE_TAG: "Tag",
      ELEMENT_TYPE_TELEPORT: "Teleport",
      ELEMENT_TYPE_TREASURE: "Treasure",
      ELEMENT_TYPE_VOICE_ANSWER: "Voice Answer",
      EMAIL: "Email",
      EMAIL_INCORRECT_REMINDER: "Incorrect Email format",
      EMPTY_CONTENT_REMINDER: "EMPTY_CONTENT_REMINDER",
      EMPTY_HOTSPOT_REMINDER: "EMPTY_HOTSPOT_REMINDER",
      EMPTY_SUBMISSION_REMINDER: "There is no submission in this VITALS.",
      ENTER_NEXT_STAGE: "Enter Next Stage Automatically",
      EVERYTHING: "Everything",
      EXPLORE: "Explore",
      EXPORT_ANSWER: "Export Answers",
      FAST: "Optimize Speed",
      FILL_IN_MIND_MAP: "FILL_IN_MIND_MAP",
      FILL_IN_MIND_MAP_DESCRIPTION: "FILL_IN_MIND_MAP_DESCRIPTION",
      FILL_IN_THE_BLANK: "FILL_IN_THE_BLANK",
      FILL_IN_THE_BLANK_DESCRIPTION: "FILL_IN_THE_BLANK_DESCRIPTION",
      FINISH: "Finish",
      FLAT_VIEW: "Flat View",
      HOTSPOT_INVISIBLE: "HOTSPOT_INVISIBLE",
      HOTSPOT_LIST: "Hotspot List",
      HOTSPOT_VISIBILITY: "HOTSPOT_VISIBILITY",
      HOTSPOT_VISIBLE: "HOTSPOT_VISIBLE",
      IMAGE: "Image",
      IMAGE_SEARCH: "IMAGE_SEARCH",
      INPUT_KEYWORD: "INPUT_KEYWORD",
      KLA_FULL: "Key Learning Area",
      KLA_SHORT: "KLA",
      LANGUAGE: "Language",
      LAST_LOGIN_TIME: "Last Login Time",
      LATITUDE: "Latitude",
      LINK: "Link",
      LINK_OTHER_MIND_MAP_BOX: "LINK_OTHER_MIND_MAP_BOX",
      LOCALE_COVER_BLANK_REMINDER: "Please upload a cover image.",
      LOCALE_CREATE_NONE: "No VITALS has been created.",
      LOCALE_INVALID_REMINDER: "VITALS is invalid",
      LOCALE_KLA_BLANK_REMINDER: "Please choose a key learning area.",
      LOCALE_MAP_BLANK_REMINDER: "LOCALE_MAP_BLANK_REMINDER",
      LOCALE_MAP_MAX_SIZE_REMINDER: "LOCALE_MAP_MAX_SIZE_REMINDER",
      LOCALE_MAP_MIN_SIZE_REMINDER: "LOCALE_MAP_MIN_SIZE_REMINDER",
      LOCALE_NAME_BLANK_REMINDER: "Name cannot be blank.",
      LOCALE_SEARCH_RESULT_NONE: "Your search did not match any VITALS.",
      LOCALE_SEARCH_TEXT_PLACEHOLDER: "keyword or school name",
      LOCALE_SUBJECT_BLANK_REMINDER: "LOCALE_SUBJECT_BLANK_REMINDER",
      LOCATION: "Location",
      LOGOUT: "Logout",
      LONGITUDE: "Longitude",
      MANUAL_START: "Manual start",
      MAP_SIZE: "Map Size (W*H)",
      MC_OF_PICTURES: "MC_OF_PICTURES",
      MC_OF_PICTURES_DESCRIPTION: "MC_OF_PICTURES_DESCRIPTION",
      MC_OF_PICTURES_MULTI: "MC_OF_PICTURES_MULTI",
      MC_OF_PICTURES_MULTI_DESCRIPTION: "MC_OF_PICTURES_MULTI_DESCRIPTION",
      MC_OF_TEXTS: "MC_OF_TEXTS",
      MC_OF_TEXTS_DESCRIPTION: "MC_OF_TEXTS_DESCRIPTION",
      MC_OF_TEXTS_MULTI: "MC_OF_TEXTS_MULTI",
      MC_OF_TEXTS_MULTI_DESCRIPTION: "MC_OF_TEXTS_MULTI_DESCRIPTION",
      MEDIA_TYPE: "Media Type",
      MIND_MAP_BOX: "MIND_MAP_BOX",
      MIND_MAP_FILL_IN_BOX: "MIND_MAP_FILL_IN_BOX",
      MIND_MAP_LABLE_BOX: "MIND_MAP_LABLE_BOX",
      MINUTE_S: "minute(s)",
      MOVE_DOWN: "Move Down",
      MOVE_UP: "Move Up",
      MOVIECLIP: "MOVIECLIP",
      MOVIECLIP_DESCRIPTION: "MOVIECLIP_DESCRIPTION",
      MY_SCHOOL: "My School",
      NAME: "Name",
      NEW_HOTSPOT: "New Hotspot",
      NEW_VITALS: "New VITALS",
      NEW_PASSWORD: "New Password",
      NEW_STAGE: "New Stage",
      NEW_STAGE_ELEMENT: "New Stage Element",
      NEXT: "Next",
      NEXT_PAGE: "Next Page",
      NO: "No",
      NO_ANSWER: "No Answer",
      NONE: "None",
      NOT_POSITIONED: "Unpositioned",
      NO_CONTENT: "Empty",
      NUMBER_OF_ATTEMPT_S: "Number of attempt(s)",
      OK: "OK",
      OLD_PASSWORD: "Old Password",
      OLD_PASSWORD_NOT_CORRECT: "Your old password is not correct",
      ORIGINAL: "Optimize Quality",
      OVERVIEW: "Overview",
      PAGE: "Page",
      PANORAMA_FORMAT: "Panorama Format",
      PASSWORD_REQUIREMENT_0: "Re-entered password incorrect",
      PASSWORD_REQUIREMENT_1: "Illegal characters, only letter and number allowed",
      PASSWORD_REQUIREMENT_2: "Password should contain both letters and digits",
      PASSWORD_REQUIREMENT_3: "Password should be longer than 6 characters",
      PASSWORD_REQUIREMENT_4: "Password should be shorter than 30 characters",
      PASSWORD_REQUIREMENT_5: "Password cannot be blank",
      PASSWORD_UPDATED: "Password updated",
      PAUSE: "Pause",
      PAUSE_VIDEO: "Pause VITALS",
      PHOTO_360: "360 Photo",
      PLAY: "Play",
      PLEASE_SELECT: "Please Select",
      PREPARING: "Preparing",
      PREVIOUS_PAGE: "Previous Page",
      POSITION: "Position",
      POSITIONTED: "Positioned",
      PRIVATE: "Private",
      PROFILE: "Profile",
      PROGRESS: "Progress",
      PUBLIC: "Public",
      PUBLISH: "Publish",
      QR_CODE: "QR Code",
      QUALITY: "Quality",
      QUESTION: "Question",
      QUESTION_DESCRIPTION: "QUESTION_DESCRIPTION",
      RADIUS: "Radius",
      RE_ENTER_NEW_PASSWORD: "Confirm New Password",
      RE_UPLOAD: "Re-Upload",
      READY: "Ready",
      REFRESH: "Refresh",
      REPORT_BUG: "Report Bug",
      REPORT_BUG_REMINDER: "REPORT_BUG_REMINDER",
      RETRIEVE_ANSWERS: "Retrieve Answers",
      ROW: "Row",
      SAFE_IMAGE_SEARCH: "Safe Image Search",
      SAVE: "Save",
      SCHOOL: "School",
      SCHOOL_LIST: "School List",
      SCHOOL_NAME: "School Name",
      SEARCH: "Search",
      SEARCH_PLACE: "Search for a place",
      SECOND_S: "second(s)",
      SECONDS: "seconds",
      SELECT: "Select",
      SELECT_IMAGE: "Select image",
      SELECT_STAGE: "Select Stage",
      SET_POSITION: "SET_POSITION",
      SETTINGS: "Settings",
      SHARABLE: "Sharable",
      SHOW_ALL_ATTEMPTS: "Show all attempts",
      SHOW_STATISTICS: "Show Statistics",
      SIMPLE_DESCRIPTION: "SIMPLE_DESCRIPTION",
      SIMPLE_DESCRIPTION_DESCRIPTION: "SIMPLE_DESCRIPTION_DESCRIPTION",
      SORT: "Sort",
      SORT_BY: "Sort By",
      SORT_CREATE_DATE_ASC: "Created (Earliest)",
      SORT_CREATE_DATE_DESC: "Created (Latest)",
      SORT_MODIFY_DATE_ASC: "Modified (Earliest)",
      SORT_MODIFY_DATE_DESC: "Modified (Latest)",
      SORT_NAME_ASC: "Name (A-Z)",
      SORT_DOWNLOAD_COUNT_ASC: "Least Downloaded",
      SORT_DOWNLOAD_COUNT_DESC: "Most Downloaded",
      STAGE_SETTINGS: "Stage Settings",
      STATUS: "Status",
      STORAGE: "Storage",
      STORAGE_MANAGEMENT: "Storage Management",
      STUDENT_ANSWER: "Studen Answer",
      SUBJECT: "Subject",
      SUBMISSION_DATE: "Submission Date",
      SUBMISSION_S: "Submission(s)",
      SUBMIT: "Submit",
      SUBMITTED: "submitted",
      SWITCH_BACK_TO_CLASSIC_UI: "Classic UI",
      SWITCH_TO_LIST: "Switch To List",
      SWITCH_TO_MAP: "Swich To Map",
      TABLE_AND_CELL: "TABLE_AND_CELL",
      TABLE_AND_CELL_DESCRIPTION: "TABLE_AND_CELL_DESCRIPTION",
      TAG_TEXT: "Tag Description",
      TAKE_PHOTO: "TAKE_PHOTO",
      TAKE_PHOTO_DESCRIPTION: "TAKE_PHOTO_DESCRIPTION",
      TAKE_RECORD: "TAKE_RECORD",
      TAKE_RECORD_DESCRIPTION: "TAKE_RECORD_DESCRIPTION",
      TARGET_USER: "Target User",
      TELEPORT: "Teleport",
      TIME: "Time",
      TITLE: "Title",
      TOTAL: "Total",
      UNSPECIFIED_SUBJECT: "Unspecified Subject",
      UNSAVED_CHANGES: "UNSAVED_CHANGES",
      UNSAVED_REMINDER: "UNSAVED_REMINDER",
      UNUSED_FILES: "Unused Files",
      UPDATE: "Update",
      UPDATE_FAILED: "Update Failed",
      UPDATE_PASSWORD: "Update Password",
      UPDATE_PROFILE: "Update Profile",
      UPDATE_TIME: "Update Time",
      UPDATED: "Updated",
      UPLOAD: "Upload",
      UPLOAD_COMPLETE: "Upload Completed",
      UPLOAD_FAILED: "Upload Failed",
      UPLOAD_FILE_SIZE_REMINDER: "File size must be less than",
      UPLOAD_FILE_TYPE_REMINDER: "File type not allowed",
      UPLOAD_FILE: "Upload file",
      UPLOAD_LOCAL_FILE: "Upload local file",
      UPLOAD_SCREENSHOT: "Upload screenshot",
      UPLOADED: "Uploaded",
      UPLOADING: "Uploading",
      USER_INFORMATION: "User Information",
      USER_LIST: "User List",
      USERNAME: "Username",
      VIDEO_360: "360 Video",
      VIEW_360: "360 View",
      VIEW_BY_SCHOOL: "View by School",
      VIEW_BY_USER: "View by User",
      VIEW_EDIT_DETAILS: "View/Edit Details",
      VIEW_PRIVATE_VITALS: "View Private VITALS",
      VIEW_PUBLIC_VITALS: "View Public VITALS",
      VISIBILITY: "Visibility",
      VITALS_NAME: "VITALS Name",
      VITALS_SIZE: "VITALS Size",
      VOICE: "Voice",
      VOICE_OVER: "VOICE_OVER",
      VOICE_OVER_DESCRIPTION: "VOICE_OVER_DESCRIPTION",
      YES: "Yes",
      ZOOM: "Zoom",
      ZOOM_IN: "Zoom In",
      ZOOM_OUT: "Zoom Out",
      ACCOUNT_DISABLING_INFO_TITLE: "License Agreement Notice",
      ACCOUNT_DISABLING_CONTENT_LV1: 'This account has been deactivated due to the license agreement mandated by The Chinese University of Hong Kong; please send an email to "clst@fed.cuhk.edu.hk" for the license renewal application.',
      ACCOUNT_DISABLING_CONTENT_LV2: 'This account has been deactivated due to the license agreement mandated by The Chinese University of Hong Kong; please send an email to "clst@fed.cuhk.edu.hk" for the license renewal application.',
      ACCOUNT_SUBSCRIPTION_NOTICE: "Account Subscription Notice",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_PRE: "Account subscription ends in ",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_POST: " days. Account expires after GMT+8 ",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_BAR: "Days until Subscription Expiry: ",
      ACCOUNT_SUBSCRIPTION_INACTIVE: "There is no active subscription plan currently.",
      ACCOUNT_SUBSCRIPTION_PERIOD: "Subscription Period(GMT+8):"
    },
    tc:{
      ACCEPT: "接受",
      ACCOUNT_SETTINGS: "帳戶設定",
      ADD: "ADD",
      ADD_CONTENT: "新增內容",
      ADD_MIND_MAP_FILL_IN_BOX: "新增填充方塊",
      ADD_MIND_MAP_LABLE_BOX: "新增描述方塊",
      ADMIN_TASK: "管理員職務",
      ALL_SCHOOLS: "ALL_SCHOOLS",
      ALL_USERS: "ALL_USERS",
      ALWAYS: "ALWAYS",
      ANSWER_SIZE: "ANSWER_SIZE",
      ATTACHMENT: "ATTACHMENT",
      AUTHOR: "作者",
      BACK: "上一步",
      CANCEL: "取消",
      CATEGORY: "分類",
      CATEGORY_CREATION: "創作",
      CATEGORY_EXPERIENCE: "體驗",
      CATEGORY_EXPERIMENT: "實驗",
      CATEGORY_EXPLORATION: "探究",
      CATEGORY_NONE: "沒分類",
      CATEGORY_KNOWLEDGE: "知識",
      CHANGE: "更改",
      CHANGE_PASSWORD: "更改密碼",
      CHOICE: "選擇",
      CLEAR: "清除",
      CLEAN_UP_ALL_VITALS: "CLEAN_UP_ALL_VITALS",
      CLEAN_UP_HIDDEN_VITALS: "CLEAN_UP_HIDDEN_VITALS",
      CLEAN_UP_UNUSED_FILES: "CLEAN_UP_UNUSED_FILES",
      CLOSE: "CLOSE",
      COLOR: "顏色",
      COLUMN: "欄",
      COMPARE_ANSWERS: "COMPARE_ANSWERS",
      CONTENT: "內容",
      CONTENT_NAME: "內容名稱",
      CONTENT_PHOTO_FILE_INSTRUCTION: "-如需要多張圖片進行描述，可創建另一個「圖文描述」\n-圖片不是「必須」但建議使用，增加學習動機\n-每個「圖文描述」文字上限為二千字",
      CONTENT_TYPE: "內容種類",
      CONTINUE_EDITING: "繼續編輯",
      CORRECT: "正確",
      CORRECT_ANSWER: "正確答案",
      COVER_IMAGE: "封面圖片",
      CREATE: "建立",
      CREATE_FAILED: "CREATE_FAILED",
      CREATE_SCHOOL: "建立學校",
      CREATE_USER: "建立用戶",
      CREATED: "已建立",
      DARK_MODE: "DARK_MODE",
      DATE_INVALID_REMINDER: "DATE_INVALID_REMINDER",
      DECLINE: "拒絕",
      DEFAULT: "DEFAULT",
      DELETE: "刪除",
      DELETE_CONTENT: "刪除內容",
      DELETE_FAILED: "刪除失敗",
      DELETE_FILE: "刪除檔案",
      DELETE_HOTSPOT: "刪除熱點",
      DELETE_LOCALE: "刪除考察",
      DELETE_MIND_MAP_BOX: "刪除方塊",
      DELETE_MIND_MAP_LINK: "移除方塊連結",
      DELETE_REMINDER: "你確定刪除？這動作不能復原",
      DELETE_STAGE: "DELETE_STAGE",
      DELETE_VITALS: "刪除VITALS",
      DELETED: "已刪除",
      DEPLOYMENT: "DEPLOYMENT",
      DESCRIPTION: "描述",
      DESCRIPTION_AUDIO: "聲音描述",
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER: "填充之後的文字",
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: "填充之前的文字",
      DESCRIPTION_IMAGE: "描述圖片",
      DESCRIPTION_QUESTION: "問題(可用HTML語法)",
      DESCRIPTION_TAKE_PHOTO: "拍攝題描述",
      DESCRIPTION_TAKE_RECORD: "錄音指示",
      DESCRIPTION_TEXT: "文字描述(可用HTML語法)",
      DESCRIPTION_VIDEO: "DESCRIPTION_VIDEO",
      DESTINATION: "DESTINATION",
      DETAILS: "細節",
      DIFFICULTY: "難度",
      DISCARD: "放棄",
      DISCARD_CHANGES: "放棄更改",
      DISPLAY_NAME: "顯示名稱",
      DISPLAY_NAME_BLANK_REMINDER: "DISPLAY_NAME_BLANK_REMINDER",
      DONE: "完成",
      DONE_EDITING: "完成編輯",
      DURATION: "DURATION",
      EDIT: "編輯",
      EDIT_CONTENT: "編輯內容",
      EDIT_ELEMENT: "EDIT_ELEMENT",
      EDIT_STAGE: "EDIT_STAGE",
      EDIT_STAGES: "EDIT_STAGES",
      EDIT_USER: "編輯用戶",
      ELEMENT_DESCRIPTION_MC: "ELEMENT_DESCRIPTION_MC",
      ELEMENT_DESCRIPTION_PORTAL: "ELEMENT_DESCRIPTION_PORTAL",
      ELEMENT_DESCRIPTION_TAG: "ELEMENT_DESCRIPTION_TAG",
      ELEMENT_DESCRIPTION_TELEPORT: "ELEMENT_DESCRIPTION_TELEPORT",
      ELEMENT_DESCRIPTION_TREASURE: "ELEMENT_DESCRIPTION_TREASURE",
      ELEMENT_DESCRIPTION_VOICE_ANSWER: "ELEMENT_DESCRIPTION_VOICE_ANSWER",
      ELEMENT_POSITION: "ELEMENT_POSITION",
      ELEMENT_TYPE: "ELEMENT_TYPE",
      ELEMENT_TYPE_MC: "ELEMENT_TYPE_MC",
      ELEMENT_TYPE_PORTAL: "ELEMENT_TYPE_PORTAL",
      ELEMENT_TYPE_TAG: "ELEMENT_TYPE_TAG",
      ELEMENT_TYPE_TELEPORT: "ELEMENT_TYPE_TELEPORT",
      ELEMENT_TYPE_TREASURE: "ELEMENT_TYPE_TREASURE",
      ELEMENT_TYPE_VOICE_ANSWER: "ELEMENT_TYPE_VOICE_ANSWER",
      EMAIL: "電郵",
      EMAIL_INCORRECT_REMINDER: "EMAIL_INCORRECT_REMINDER",
      EMPTY_CONTENT_REMINDER: "未有任何熱點內容，請按加號創建新的內容",
      EMPTY_HOTSPOT_REMINDER: "這考察未有任何熱點，若這是你的考察，請按上方的加號創建新的熱點",
      EMPTY_SUBMISSION_REMINDER: "EMPTY_SUBMISSION_REMINDER",
      ENTER_NEXT_STAGE: "ENTER_NEXT_STAGE",
      EVERYTHING: "EVERYTHING",
      EXPLORE: "探索",
      EXPORT_ANSWER: "匯出答案",
      FAST: "Optimize Speed",
      FILL_IN_MIND_MAP: "填充概念題",
      FILL_IN_MIND_MAP_DESCRIPTION: "填上概念圖上的空位",
      FILL_IN_THE_BLANK: "填充",
      FILL_IN_THE_BLANK_DESCRIPTION: "填上缺漏的文字",
      FINISH: "完成",
      FLAT_VIEW: "FLAT_VIEW",
      HOTSPOT_INVISIBLE: "隱藏顯示",
      HOTSPOT_LIST: "熱點列表",
      HOTSPOT_VISIBILITY: "顯示熱點",
      HOTSPOT_VISIBLE: "正常顯示",
      IMAGE: "IMAGE",
      IMAGE_SEARCH: "圖片搜尋",
      INPUT_KEYWORD: "輸入關鍵字",
      KLA_FULL: "學習領域",
      KLA_SHORT: "學習領域",
      LANGUAGE: "語言",
      LAST_LOGIN_TIME: "上次登入時間",
      LATITUDE: "緯度",
      LINK: "LINK",
      LINK_OTHER_MIND_MAP_BOX: "連結其他方塊",
      LOCALE_COVER_BLANK_REMINDER: "請上載一張封面圖片",
      LOCALE_INVALID_REMINDER: "LOCALE_INVALID_REMINDER",
      LOCALE_KLA_BLANK_REMINDER: "請選擇一個學習領域",
      LOCALE_MAP_BLANK_REMINDER: "請設定考察範圍",
      LOCALE_MAP_MAX_SIZE_REMINDER: "考察範圍太廣，請把地圖縮放度設為大於15",
      LOCALE_MAP_MIN_SIZE_REMINDER: "考察範圍太窄",
      LOCALE_NAME_BLANK_REMINDER: "名稱不能為空白",
      LOCALE_SEARCH_RESULT_NONE: "未有符合的考察，請嘗試其他查詢方法",
      LOCALE_SEARCH_TEXT_PLACEHOLDER: "關鍵字或學校名稱",
      LOCALE_SUBJECT_BLANK_REMINDER: "請選擇一個學科",
      LOCATION: "地點",
      LOGOUT: "登出",
      LONGITUDE: "經度",
      MANUAL_START: "手動開始",
      MAP_SIZE: "地圖大小 (長*高)",
      MC_OF_PICTURES: "圖片選擇題",
      MC_OF_PICTURES_DESCRIPTION: "選擇最正確圖片答案",
      MC_OF_PICTURES_MULTI: "圖片多項選擇",
      MC_OF_PICTURES_MULTI_DESCRIPTION: "選擇多個圖片答案",
      MC_OF_TEXTS: "文字選擇題",
      MC_OF_TEXTS_DESCRIPTION: "選擇最正確文字答案",
      MC_OF_TEXTS_MULTI: "文字多項選擇",
      MC_OF_TEXTS_MULTI_DESCRIPTION: "選擇多個文字答案",
      MEDIA_TYPE: "MEDIA_TYPE",
      MIND_MAP_BOX: "方塊",
      MIND_MAP_FILL_IN_BOX: "填充方塊",
      MIND_MAP_LABLE_BOX: "描述方塊",
      MINUTE_S: "MINUTE_S",
      MOVE_DOWN: "向上移",
      MOVE_UP: "向下移",
      MOVIECLIP: "短片介紹",
      MOVIECLIP_DESCRIPTION: "mov播放",
      MY_SCHOOL: "MY_SCHOOL",
      NAME: "名稱",
      NEW_HOTSPOT: "新熱點",
      NEW_VITALS: "新VITALS",
      NEW_PASSWORD: "新密碼",
      NEW_STAGE: "NEW_STAGE",
      NEW_STAGE_ELEMENT: "NEW_STAGE_ELEMENT",
      NEXT: "下一步",
      NEXT_PAGE: "下一頁",
      NO: "否",
      NO_ANSWER: "NO_ANSWER",
      NONE: "NONE",
      NOT_POSITIONED : "未選定位置",
      NO_CONTENT: "沒內容",
      NUMBER_OF_ATTEMPT_S: "NUMBER_OF_ATTEMPT_S",
      OK: "好",
      OLD_PASSWORD: "舊密碼",
      OLD_PASSWORD_NOT_CORRECT: "OLD_PASSWORD_NOT_CORRECT",
      ORIGINAL: "Optimize Quality",
      OVERVIEW: "OVERVIEW",
      PAGE: "頁",
      PANORAMA_FORMAT: "PANORAMA_FORMAT",
      PASSWORD_REQUIREMENT_0: "PASSWORD_REQUIREMENT_0",
      PASSWORD_REQUIREMENT_1: "PASSWORD_REQUIREMENT_1",
      PASSWORD_REQUIREMENT_2: "PASSWORD_REQUIREMENT_2",
      PASSWORD_REQUIREMENT_3: "PASSWORD_REQUIREMENT_3",
      PASSWORD_REQUIREMENT_4: "PASSWORD_REQUIREMENT_4",
      PASSWORD_REQUIREMENT_5: "PASSWORD_REQUIREMENT_5",
      PASSWORD_UPDATED: "PASSWORD_UPDATED",
      PAUSE: "PAUSE",
      PAUSE_VIDEO: "PAUSE_VIDEO",
      PHOTO_360: "PHOTO_360",
      PLAY: "PLAY",
      PLEASE_SELECT: "請選擇",
      POSITION: "位置",
      POSITIONTED: "已選定位置",
      PREPARING: "準備中",
      PREVIOUS_PAGE: "上一頁",
      PRIVATE: "PRIVATE",
      PROFILE: "PROFILE",
      PROGRESS: "進度",
      PUBLIC: "公開",
      PUBLISH: "發布",
      QR_CODE: "QR_CODE",
      QUALITY: "QUALITY",
      QUESTION: "問題",
      QUESTION_DESCRIPTION: "文字或圖片短答問題",
      RADIUS: "半徑",
      RE_ENTER_NEW_PASSWORD: "再次輸入新密碼",
      RE_UPLOAD: "RE_UPLOAD",
      READY: "就緒",
      REFRESH: "刷新",
      REPORT_BUG: "匯報漏洞",
      REPORT_BUG_REMINDER: "REPORT_BUG_REMINDER",
      RETRIEVE_ANSWERS: "RETRIEVE_ANSWERS",
      ROW: "行",
      SAFE_IMAGE_SEARCH: "安全搜尋圖片",
      SAVE: "儲存",
      SCHOOL: "SCHOOL",
      SCHOOL_LIST: "學校列表",
      SCHOOL_NAME: "學校名稱",
      SEARCH: "搜尋",
      SEARCH_PLACE: "SEARCH_PLACE",
      SECOND_S: "SECOND_S",
      SECONDS: "SECONDS",
      SELECT: "選擇",
      SELECT_IMAGE: "選擇圖片",
      SELECT_STAGE: "SELECT_STAGE",
      SET_POSITION: "設定位置",
      SETTINGS: "設定",
      SHARABLE: "是否共享",
      SHOW_ALL_ATTEMPTS: "SHOW_ALL_ATTEMPTS",
      SHOW_STATISTICS: "SHOW_STATISTICS",
      SIMPLE_DESCRIPTION: "圖文描述",
      SIMPLE_DESCRIPTION_DESCRIPTION: "簡單文字及圖片描述",
      SORT: "SORT",
      SORT_BY: "排序",
      SORT_CREATE_DATE_ASC: "由最早建立",
      SORT_CREATE_DATE_DESC: "由最近建立",
      SORT_MODIFY_DATE_ASC: "由最早更新",
      SORT_MODIFY_DATE_DESC: "由最近更新",
      SORT_NAME_ASC: "名稱(A-Z)",
      SORT_DOWNLOAD_COUNT_ASC: "最多下載次數",
      SORT_DOWNLOAD_COUNT_DESC: "最少下載次數",
      STAGE_SETTINGS: "STAGE_SETTINGS",
      STATUS: "STATUS",
      STORAGE: "STORAGE",
      STORAGE_MANAGEMENT: "STORAGE_MANAGEMENT",
      STUDENT_ANSWER: "STUDENT_ANSWER",
      SUBJECT: "學科",
      SUBMISSION_DATE: "SUBMISSION_DATE",
      SUBMISSION_S: "SUBMISSION_S",
      SUBMIT: "提交",
      SUBMITTED: "SUBMITTED",
      SWITCH_BACK_TO_CLASSIC_UI: "經典用戶界面",
      SWITCH_TO_LIST: "切換至列表",
      SWITCH_TO_MAP: "切換至地圖",
      TABLE_AND_CELL: "自訂列表",
      TABLE_AND_CELL_DESCRIPTION: "製作列表/統計問題",
      TAG_TEXT: "TAG_TEXT",
      TAKE_PHOTO: "拍照題",
      TAKE_PHOTO_DESCRIPTION: "要求拍攝或繪畫",
      TAKE_RECORD: "錄音或訪問",
      TAKE_RECORD_DESCRIPTION: "要求學生錄音",
      TARGET_USER: "TARGET_USER",
      TELEPORT: "TELEPORT",
      TIME: "時間",
      TITLE: "標題",
      TOTAL: "TOTAL",
      UNSPECIFIED_SUBJECT: "沒特定科目",
      UNSAVED_CHANGES: "UNSAVED_CHANGES",
      UNSAVED_REMINDER: "UNSAVED_REMINDER",
      UNUSED_FILES: "UNUSED_FILES",
      UPDATE: "更新",
      UPDATE_FAILED: "更新失敗",
      UPDATE_PASSWORD: "更新密碼",
      UPDATE_PROFILE: "更新個人資料",
      UPDATE_TIME: "UPDATE_TIME",
      UPDATED: "已更新",
      UPLOAD: "上載",
      UPLOAD_COMPLETE: "上載完成",
      UPLOAD_FAILED: "上載失敗",
      UPLOAD_FILE_SIZE_REMINDER: "檔案大小需少於",
      UPLOAD_FILE_TYPE_REMINDER: "UPLOAD_FILE_TYPE_REMINDER",
      UPLOAD_FILE: "上載檔案",
      UPLOAD_LOCAL_FILE: "上載本機檔案",
      UPLOAD_SCREENSHOT: "上載截圖",
      UPLOADED: "已上載",
      UPLOADING: "上載中",
      USER_INFORMATION: "用戶資料",
      USER_LIST: "用戶列表",
      USERNAME: "用戶名稱",
      VIDEO_360: "VIDEO_360",
      VIEW_360: "VIEW_360",
      VIEW_BY_SCHOOL: "VIEW_BY_SCHOOL",
      VIEW_BY_USER: "VIEW_BY_USER",
      VIEW_EDIT_DETAILS: "VIEW_EDIT_DETAILS",
      VIEW_PRIVATE_VITALS: "VIEW_PRIVATE_VITALS",
      VIEW_PUBLIC_VITALS: "VIEW_PUBLIC_VITALS",
      VISIBILITY: "VISIBILITY",
      VITALS_NAME: "VITALS_NAME",
      VITALS_SIZE: "VITALS_SIZE",
      VOICE: "VOICE",
      VOICE_OVER: "聲音導航",
      VOICE_OVER_DESCRIPTION: "mp3音效檔播放",
      YES: "是",
      ZOOM: "縮放",
      ZOOM_IN: "放大",
      ZOOM_OUT: "縮小",
      ACCOUNT_DISABLING_INFO_TITLE: "License Agreement Notice",
      ACCOUNT_DISABLING_CONTENT_LV1: 'This account has been deactivated due to the license agreement mandated by The Chinese University of Hong Kong; please send an email to "clst@fed.cuhk.edu.hk" for the license renewal application.',
      ACCOUNT_DISABLING_CONTENT_LV2: 'This account has been deactivated due to the license agreement mandated by The Chinese University of Hong Kong; please send an email to "clst@fed.cuhk.edu.hk" for the license renewal application.',
      ACCOUNT_SUBSCRIPTION_NOTICE: "Account Subscription Notice",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_PRE: "Account subscription ends in ",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_POST: " days. Account expires after GMT+8 ",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_BAR: "Days until Subscription Expiry: ",
      ACCOUNT_SUBSCRIPTION_INACTIVE: "There is no active subscription plan currently.",
      ACCOUNT_SUBSCRIPTION_PERIOD: "Subscription Period(GMT+8):"
    },
  })
}

export default Localization;
